import { useState } from 'react';
import { useWheel } from '../context/WheelContext';
import { DocumentArrowDownIcon, TrashIcon } from '@heroicons/react/24/solid';

function WinnersHistory() {
  const { winners, clearWinners, exportWinnersToExcel } = useWheel();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(winners.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentWinners = winners.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-secondary-900">Historial de Ganadores</h2>
        <div className="flex gap-2">
          {winners.length > 0 && (
            <>
              <button
                onClick={exportWinnersToExcel}
                className="flex items-center gap-2 px-3 py-1.5 text-secondary-700 bg-secondary-100 rounded-lg hover:bg-secondary-200 transition-colors"
                title="Exportar historial"
              >
                <DocumentArrowDownIcon className="h-5 w-5" />
                <span className="text-sm">Exportar a Excel</span>
              </button>
              <button
                onClick={clearWinners}
                className="flex items-center gap-2 px-3 py-1.5 text-white bg-danger-500 rounded-lg hover:bg-danger-600 transition-colors"
                title="Limpiar historial"
              >
                <TrashIcon className="h-5 w-5" />
                <span className="text-sm">Limpiar historial</span>
              </button>
            </>
          )}
        </div>
      </div>

      {winners.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-secondary-200">
                  <th className="py-3 px-4 text-left text-secondary-600">Nombre</th>
                  <th className="py-3 px-4 text-left text-secondary-600">Fecha</th>
                  <th className="py-3 px-4 text-left text-secondary-600">Modo</th>
                </tr>
              </thead>
              <tbody>
                {currentWinners.map((winner, index) => (
                  <tr 
                    key={winner.date}
                    className={`
                      border-b border-secondary-100 
                      ${index % 2 === 0 ? 'bg-secondary-50' : 'bg-white'}
                    `}
                  >
                    <td className="py-3 px-4 font-medium">{winner.name}</td>
                    <td className="py-3 px-4 text-secondary-600">
                      {new Date(winner.date).toLocaleString()}
                    </td>
                    <td className="py-3 px-4">
                      <span className={`
                        inline-flex items-center gap-1 px-2 py-1 rounded-full text-sm
                        ${winner.mode === 'shark' 
                          ? 'bg-blue-100 text-blue-700' 
                          : 'bg-secondary-100 text-secondary-700'}
                      `}>
                        {winner.mode === 'shark' ? '🦈 Tiburón' : '🎲 Normal'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Paginación */}
          {totalPages > 1 && (
            <div className="flex justify-center gap-2 mt-4">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Anterior
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  onClick={() => handlePageChange(i + 1)}
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === i + 1
                      ? 'bg-blue-500 text-white'
                      : 'bg-gray-100 hover:bg-gray-200'
                  }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Siguiente
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-8 text-secondary-600">
          No hay ganadores registrados aún
        </div>
      )}
    </div>
  );
}

export default WinnersHistory; 